<template>
  <div class="body">
    <div class="main_container">
        <training-header :appConfig = "appConfig"  ></training-header>

      <div class="right_col" role="main" style="margin-left: 0;">
        <br />

        <div class="row">
          <div class="col-lg-10 mx-auto">
            <div class="x_panel">
              <div class="x_title">
                <h2 style="font-weight: 600;">{{facilitatorObj.roleHeader}}</h2>

                <div class="clearfix"></div>
              </div>
              <div class="x_content">
                <div class="dashboard-widget-content" v-html="facilitatorObj.roleContent">

                  <!-- <ul class="to_do" >
                    <li>
                      <p>
                        <span class="fa fa-circle" style="padding: 4px;"></span>
                        <span
                          style="margin-left: 11px;"
                        >You are a resource person with a good knowledge in family planning, preferably a Track 20 M&E officer, FP consultants, medical officer, strategic decision - making government officer, DHIS2 team member, Technical support group member or any other FP health care provider.</span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span class="fa fa-circle" style="padding: 4px;"></span>
                        <span
                          style="margin-left: 11px;"
                        >You must have a good knowledge in the country family planning program and understand the government structures that collect, analyze and use family planning data. It is essential that you should have completed this course earlier.</span>
                      </p>
                    </li>

                    <li>
                      <p>
                        <span class="fa fa-circle" style="padding: 4px;"></span>
                        <span style="margin-left: 11px;">
                          You help to support the learners of the Family Planning training by developing a learning plan, creating an agenda, conducting didactic sessions, responding to learner’s
                          queries facilitating learners access to the web based modules and providing indirect or unobtrusive assistance, guidance and supervision. Remember to give feedback on the course to Avenir Health using the template mailed to you.
                        </span>
                      </p>
                    </li>

                    <li>
                      <p>
                        <span class="fa fa-circle" style="padding: 4px;"></span>
                        <span
                          style="margin-left: 11px;"
                        >“Good teachers never teach anything. What they do is create the conditions under which learning takes place.” ~ S.I. Hayakawa</span>
                      </p>
                    </li>
                    <li>
                      <br />
                    </li>
                  </ul> -->
                </div>

                <div style="text-align: center; margin-bottom: 3%;">

                  <router-link :to="{ name: 'facilitator-page', params: { facilitatorObj: facilitatorObj ,appConfig: appConfig}}"   class="btn-bottom" style="margin-right: 5%;">
                    <i
                      class="fa fa-angle-double-left"
                      aria-hidden="true"
                      style="padding-right: 1%;"
                    ></i> Previous
                  </router-link>

                  <router-link :to="{ name: 'facilitator-menu', params: { facilitatorObj: facilitatorObj ,appConfig: appConfig}}"   class="btn-bottom" style="color: #3471ce;">
                     Next
                     <i
                       class="fa fa-angle-double-right"
                       aria-hidden="true"
                       style="padding-left: 1%;"
                     ></i>
                  </router-link>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <training-footer :appConfig="appConfig"></training-footer>
    </div>
  </div>
</template>
<script>
import trainingHeader from '../components/trainingHeader';
import trainingFooter from '../components/trainingFooter';
export default {
    components: {
        trainingHeader,
        trainingFooter
    },
    data(){
      return {
        facilitatorObj:{},
        appConfig:{}
      }
    },
    mounted(){
      if(this.$route.params.facilitatorObj){
      this.facilitatorObj = this.$route.params.facilitatorObj
    }
      if(this.$route.params.appConfig){
      this.appConfig = this.$route.params.appConfig
      }
    },
}
</script>
<style scoped>
    .x_panel {
        background-color: #fff;
        border: 0px solid transparent;
        padding:0;
        border-radius: 7px;
    }
    .x_title {
        border-bottom: 0px solid #E6E9ED;
        padding: 15px 18px;
        background-color: #b0b0b0;
        color: #fff;
        border-radius: 7px 7px 0 0;
    }
    .x_content {
        padding: 0 25px 6px;
    }
    .right_col{
          justify-content: center;
          align-items: center;
          display: flex;
        }
</style>
